import { useContext, useMemo } from 'react';
import { UserContext } from '../../common/auth/UserContext';
import {
    LIGHTING_PROFESSIONAL,
    MARKETPLACE,
    PLANNING,
    PRODUCTION_CONNECT,
    PRODUCTION_PROFESSIONAL,
    PROFILES,
    RESERVATION_PROFESSIONAL,
    SUPPLIER
} from '../../common/nav/apps';

export default () => {
    const { application } = useContext(UserContext);

    const preFilterByApp = useMemo(() => {
        return {
            [MARKETPLACE.id]: [{ identifier: 'public', value: 'false' }],
            [SUPPLIER.id]: [{ identifier: 'public', value: 'false' }],
            [PLANNING.id]: [{ identifier: 'public', value: 'false' }],
            [PROFILES.id]: [{ identifier: 'public', value: 'false' }],
            [PRODUCTION_PROFESSIONAL.id]: [{ identifier: 'public', value: 'false' }],
            [LIGHTING_PROFESSIONAL.id]: [{ identifier: 'public', value: 'false' }],
            [RESERVATION_PROFESSIONAL.id]: [{ identifier: 'public', value: 'false' }],
            [PRODUCTION_CONNECT.id]: [{ identifier: 'public', value: 'false' }]
        };
    }, []);

    return preFilterByApp[application.id];
};
